import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';

const propTypes = {
  navigationItems: PropTypes.array.isRequired,
  navigationItemClickHandler: PropTypes.func,
};

const MainNavigation = (props) => (
  <nav className="main-navigation">
    {props.navigationItems.map((item) => (
      <Link
        to={item.path}
        key={item.titleKey}
        className={cx({
          'main-navigation__link': true,
          [`main-navigation__link--type-${item.type}`]: item.type,
        })}
        activeClassName="main-navigation__link--active"
        onClick={props.navigationItemClickHandler}
      >
        <FormattedMessage id={item.titleKey} tagName="span" />
      </Link>
    ))}
  </nav>
);

MainNavigation.propTypes = propTypes;

export default MainNavigation;
